export * from './resource-pixels.component';
